export default {
  moneySymbol: 'UZS',
  form: {
    lightFilter: {
      more: 'Yana',
      clear: 'Tozalash',
      confirm: 'OK',
      itemUnit: 'Pozitsiyalar'
    }
  },
  tableForm: {
    search: 'Qidirish',
    reset: 'Qayta tiklash',
    submit: 'Yuborish',
    collapsed: 'Yig‘ish',
    expand: 'Kengaytirish',
    inputPlaceholder: 'Qiymatni kiriting',
    selectPlaceholder: 'Qiymatni tanlang'
  },
  alert: {
    clear: 'Tozalash',
    selected: 'Tanlangan',
    item: 'elementlar'
  },
  pagination: {
    total: {
      range: ' ',
      total: 'dan',
      item: 'elementlar'
    }
  },
  tableToolBar: {
    leftPin: 'Chapga mahkamlash',
    rightPin: 'O‘ngga mahkamlash',
    noPin: 'Mahkamlashni olib tashlash',
    leftFixedTitle: 'Chapga mahkamlangan',
    rightFixedTitle: 'O‘ngga mahkamlangan',
    noFixedTitle: 'Mahkamlashsiz',
    reset: 'Qayta tiklash',
    columnDisplay: 'Ustunni ko‘rsatish',
    columnSetting: 'Sozlamalar',
    fullScreen: 'To‘liq ekran',
    exitFullScreen: 'To‘liq ekrandan chiqish',
    reload: 'Yangilash',
    density: 'O‘lcham',
    densityDefault: 'Standart',
    densityLarger: 'Katta',
    densityMiddle: 'O‘rtacha',
    densitySmall: 'Kichik'
  },
  stepsForm: {
    next: 'Keyingi',
    prev: 'Oldingi',
    submit: 'Tugatish'
  },
  loginForm: {
    submitText: 'Kirish'
  },
  editableTable: {
    action: {
      save: 'Saqlash',
      cancel: 'Bekor qilish',
      delete: 'O‘chirish',
      add: 'maʼlumotlar qatorini qo‘shish'
    }
  },
  switch: {
    open: 'Ochish',
    close: 'Yopish'
  }
};